/* eslint-disable @next/next/no-img-element */
import cx from 'classnames';
import CameraPermission from 'components/Icons/CameraPermission';
import UIButton from 'components/Others/UIButton';
import Spinner from 'components/Spinner/Spinner';
import useInterval from 'hooks/useInterval';
import { Transition } from '@headlessui/react';
import useWindowSize from 'hooks/useWindowSize';
import Image from "next/legacy/image";
import { FC, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCalculateHeadSize, setCalculatePd, setFaceStates, setPdValues, setShowResult, setShowWelcomeScreen, setShowModal } from 'redux/features/pd/pdSlice';
import PDLoadingImage from '../../public/pd/loading.jpg';
import Face from './Face';
import FaceBackground from './FaceBackground';
import { MEDIA_STEAM_CONSTRAINTS } from './PD.constants';
import { CalculateCenterToIris, CalculateHeadSize, CalculatePD, PDBootstrap, PDCleanup, reset, UpdateState, VideoPause, VideoPlay } from './PD.types';
import PDCaptureOverlay from './PDCaptureOverlay';
import { addDataLayer } from 'lib/ga';
import PDCamera from 'components/Icons/PDCamera';
import * as ga from '../../lib/ga';


const PDCameraView: FC<{
  // eslint-disable-next-line no-unused-vars
  updateLockModal: (value: boolean) => void;
  onReady?: () => void;
  handleRecalculate: () => void;
  deviceType: 'mobile' | 'desktop';
  hideOverlay: () => void;
  refresh: number;
  visible: boolean;
}> = ({
  updateLockModal,
  onReady,
  deviceType,
  hideOverlay,
  handleRecalculate,
  refresh,
  visible
}) => {
    const [videoStream, setVideoStream] = useState<MediaStream | null>(null);
    const videoRef = useRef<HTMLVideoElement>(null);
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const showResult = useSelector((state: any) => state.pdEvent.showResult);
    const { width } = useWindowSize();

    const [isCameraReady, setIsCameraReady] = useState(false);
    const [showPermissionNotGrandedAlert, setShowPermissionNotGrandedAlert] =
      useState(false);

    const [isCalculating, setIsCalculating] = useState(false)

    const [pdMeterStates, setPdMeterStates] = useState({

    })

    const PDBootstrap = useRef<PDBootstrap | null>(null);

    const PDCleanup = useRef<PDCleanup | null>(null);

    const CalculatePD = useRef<CalculatePD | null>(null);

    const CalculateHeadSize = useRef<CalculateHeadSize | null>(null);

    const CalculateCenterToIris = useRef<CalculateCenterToIris | null>(null);

    const VideoPause = useRef<VideoPause | null>(null);
    const VideoPlay = useRef<VideoPlay | null>(null);

    const UpdateState = useRef<UpdateState | null>(null);

    const Reset = useRef<reset | null>(null);

    const [componentKey, setComponentKey] = useState(0)


    const [faceState, setFaceState] = useState({
      isTooFar: false,
      straight: false,
      pdValues: 0
    })

    const pdValues = useSelector((state: any) => state.pdEvent.pdValues);
    const showWelcomeScreen = useSelector((state: any) => state.pdEvent.showWelcomeScreen);


    const loadUtils = async () => {
      const PDUtils = await import('./PD.utils');
      await PDUtils.loadAssets();
      PDBootstrap.current = PDUtils.bootstrap;
    };

    const initializeCamera = async () => {
      //addDataLayer({ event: 'pdMeterStart' }, false);
      ga.sendUICustomEvent({
        eventCategory: 'Pd Meter',
        eventAction: 'Start',
        eventLabel: 'Start',
      })
      try {
        updateLockModal(true);
        setShowPermissionNotGrandedAlert(false);
        const [stream] = await Promise.all([
          navigator.mediaDevices.getUserMedia(MEDIA_STEAM_CONSTRAINTS),
          loadUtils()
        ]);
        setVideoStream(stream);
        localStorage.setItem('cameraPermission', 'true');
      } catch {
        setShowPermissionNotGrandedAlert(true);
        localStorage.setItem('cameraPermission', 'false');
      } finally {
        updateLockModal(false);
      }
    };

    useEffect(() => {

      /*if(window.innerWidth > 950){ 
        initializeCamera();
        return () => cleanupCameraAccess();
      }*/

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
      dispatch(setPdValues(0))
      return;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      isCameraReady
    ]);

    useEffect(() => {
      if (!videoRef.current || !videoStream || !canvasRef.current) return;
      const initailizePD = async () => {
        if (!videoRef.current || !videoStream || !canvasRef.current) return;

        if (!PDBootstrap.current) await loadUtils();

        const bootstrap = async () => {
          if (
            !videoRef.current ||
            !videoStream ||
            !canvasRef.current ||
            !PDBootstrap.current
          )
            return;

          setIsCameraReady(false);

          const { cleanup, calculatePd, calculateHeadSize, calculateCenterToIris, updateState, videoPause, videoPlay, reset } = await PDBootstrap.current?.({
            videoElement: videoRef.current,
            canvasElement: canvasRef.current
          }, handleVideoState, window);

          PDCleanup.current = cleanup;
          CalculatePD.current = calculatePd;
          CalculateCenterToIris.current = calculateCenterToIris;
          CalculateHeadSize.current = calculateHeadSize;
          UpdateState.current = updateState;
          VideoPause.current = videoPause;
          VideoPlay.current = videoPlay;
          Reset.current = reset;
          /*if(window.innerWidth < 950) {
            UpdateState.current?.(true)
          }*/
          onReady?.();
          setIsCameraReady(true);

        };

        bootstrap();
      };

      videoRef.current.srcObject = videoStream;
      initailizePD();

      return () => {
        cleanupCameraAccess();
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoRef, videoStream]);

    useEffect(() => {
      VideoPlay.current?.()
      dispatch(setShowResult(false))
      //dispatch(setShowWelcomeScreen(true))
      UpdateState?.current?.(false)
      Reset.current?.()
      // console.log("HANDLE CALCULATE")
    }, [handleRecalculate])

    const handleVideoState = (faceState: any) => {
      setFaceState(faceState)
      dispatch(setFaceStates(faceState))
      if (faceState.isFinished == true && faceState.pd) {
        dispatch(setCalculatePd(faceState.pd))
        dispatch(setCalculateHeadSize(faceState.headSize))
        dispatch(setShowResult(true))
        //addDataLayer({ event: 'pdMeasureSuccess', 'headSize':faceState.headSize, 'pd':faceState.pd}, false);
        ga.sendUICustomEvent({
          eventCategory: 'Pd Meter',
          eventAction: 'Success',
          eventLabel: 'headSize: ' + faceState.headSize + ' - pd:' + faceState.pd,
        })
      }
    }

    const cleanupCameraAccess = () => {
      if (!videoStream) return;
      videoStream?.getTracks().forEach((track) => {
        track.enabled = false;
        track.stop();
      });
      if (videoRef.current) videoRef.current.srcObject = null;
      PDCleanup.current?.();

      setVideoStream(null);
    };
    const dispatch = useDispatch()

    const handleCountdownComplete = () => {
      UpdateState?.current?.(true)
      // console.log("handle countdown complete");
    }


    useEffect(() => {
      if (!CalculatePD.current && !CalculateCenterToIris.current && !CalculateHeadSize.current) return;


      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [CalculatePD.current]);

    useEffect(() => {
      Reset.current?.().then((data) => {
        dispatch(setShowResult(false))
        /*CalculateHeadSize.current?.().then((data) => {
          dispatch(setCalculateHeadSize(data))
        })
        CalculatePD.current?.().then((data) => {
          dispatch(setCalculatePd(data.pd))
        })
        CalculateCenterToIris.current?.().then((data) => {
          dispatch(setCalculateCenterToIris(data))
        })*/
      })

    }, [refresh])

    useEffect(() => {
      /*if(showWelcomeScreen === false && window.innerWidth > 950){
        initializeCamera();
      }*/
      if (showWelcomeScreen === false) {
        // UpdateState?.current?.(true)
      }

      if (showWelcomeScreen === false) {
        initializeCamera();
        return () => cleanupCameraAccess();
      }

    }, [showWelcomeScreen])

    useEffect(() => {
      if (showWelcomeScreen === false) {
        //UpdateState?.current?.(true)
      }
    }, [UpdateState.current])

    useEffect(() => {
      return () => {
        UpdateState?.current?.(false)
        dispatch(setShowWelcomeScreen(true))
        dispatch(setPdValues(0))
        //dispatch(setShowModal(false))
      }
    }, [visible])

    return (
      <div className="relative flex h-full w-full bg-brand-black100" style={{ 'transform': 'scale(1.5)' }}>
        {showPermissionNotGrandedAlert ? (
          <PDCameraPermissionWarning onRetry={() => initializeCamera()} />
        ) : (
          <>
            <div
              className={
                isCameraReady
                  ? 'flex w-full items-center justify-center'
                  : 'hidden'
              }>
              {(!showWelcomeScreen && isCameraReady) && <PDCountdown timerSeconds={3} onCountdownCompleted={handleCountdownComplete} />}
              <video
                ref={videoRef}
                autoPlay
                playsInline
                className="hidden h-full w-full object-cover"
                loop
                muted
              />
              <canvas
                ref={canvasRef}
                className="PD-canvas !h-full !w-full object-cover object-center" style={{
                  transform: "scaleX(-1)"
                }}></canvas>
            </div>
            {!isCameraReady && (
              <div className="relative flex h-full w-full items-center justify-center">

                <div className="absolute customPdSize:flex customPdSize:top-[213px] customPdSize:left-0 customPdSize:right-0 z-10 left-0 right-0 top-[125px] h-full">
                  <Face stroke={"#11F9AF"} className={cx(
                    'customPdSize:absolute z-[2] w-[155px] mx-auto customPdSize:w-[286px] left-0 right-0',
                    {
                      'top-0 ': !faceState.isTooFar,
                      ' ': faceState.straight
                    }
                  )} style={width < 950 ? { top: `calc(50% - 410px)` } : {}} />
                </div>
                <span id="faceBackground">
                  <FaceBackground
                    className={cx(
                      "absolute z-[1] left-0 right-0 mx-auto top-0",
                    )} style={width < 950 ? { left: `calc(50% - 503px)`, top: `calc(50% - 542px)`, transform: `scale(0.8)` } : {}} />
                </span>

                <Image
                  layout="fill"
                  alt="Loading..."
                  src={PDLoadingImage}
                  objectFit="cover"
                  sizes="100vw"
                  //style={{ width: '100%', height: 'auto' }}
                />

                {(!showWelcomeScreen && !localStorage.getItem('cameraPermission')) && <div className='z-10 absolute bg-[#00000040] w-full top-0 left-0 h-full items-center flex' style={{ 'transform': 'scale(0.7)' }}>
                  <div className='p-8 rounded w-72 mx-auto text-center bg-white text-black text-base font-medium'>
                    <PDCamera className='mx-auto mb-4 ' />
                    First, grant browser access to your webcam.</div>
                </div>}

              </div>
            )}
            {isCameraReady && (
              <div className="absolute top-0 text-center left-0 z-[1] h-full w-full">
                <PDCaptureOverlay
                  hideOverlay={hideOverlay}
                  device={deviceType}
                />
                <div>
                  <div className="w-full h-full">
                    <div className="w-full h-1 bg-white z-1 absolute left-0 right-0 mx-auto top-0 rounded-xl">
                      <div className=' bg-brand-yellow rounded-lg h-1 z-10 absolute' style={{
                        width: (showWelcomeScreen ? 0 : pdValues * 5) + '%'
                      }}></div>
                    </div>
                    <div className="absolute customPdSize:flex customPdSize:top-[213px] customPdSize:left-0 customPdSize:right-0 z-10 left-0 right-0 top-[125px] h-full">
                      <Face strokeDasharray={faceState.isTooFar == true ? '0.2 8' : ''} stroke={(!faceState.isTooFar && faceState.straight) ? '#11F9AF' : ((faceState.isTooFar == false) ? '#FFC728' : 'white')} className={cx(
                        'customPdSize:absolute z-[2] w-[155px] mx-auto customPdSize:w-[286px] left-0 right-0',
                        {
                          'top-0 ': !faceState.isTooFar,
                          ' ': faceState.straight
                        }
                      )} style={width < 950 ? { top: `calc(50% - 410px)` } : {}} />
                    </div>
                    <span id="faceBackground">
                      <FaceBackground
                        className={cx(
                          "absolute left-0 right-0 mx-auto top-0",
                        )} style={width < 950 ? { left: `calc(50% - 503px)`, top: `calc(50% - 542px)`, transform: `scale(0.8)` } : {}} />
                    </span>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    );
  };


const PDCountdown: FC<{
  timerSeconds: number;
  onCountdownCompleted: () => void;
}> = ({ timerSeconds, onCountdownCompleted }) => {
  const [isCountdownVisible, setIsCountdownVisible] = useState(true);

  const [countdownSecond, setCountdownSecond] = useState(timerSeconds);
  useInterval(() => {
    if (countdownSecond === 0) {
      onCountdownCompleted();
      setIsCountdownVisible(false);
      return;
    }
    setIsCountdownVisible(false);
    setTimeout(() => {
      setCountdownSecond(countdownSecond - 1);
      setIsCountdownVisible(true);
    }, 500);
  }, 1250);
  return (
    <div className="absolute left-0 top-0 z-10 flex h-full  w-full items-center justify-center opacity-75">
      <Transition
        appear
        show={isCountdownVisible}
        enter="transition-all duration-[400ms]"
        enterFrom="opacity-0 transform scale-0"
        enterTo="opacity-100 scale-100"
        leave="transition-all duration-[200ms]"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-0"
        className="mb-[60px] text-[72px] font-medium text-white sm:mb-0">
        {countdownSecond === 0 ? '' : countdownSecond}
      </Transition>
    </div>
  );
};


const PDCameraPermissionWarning: FC<{
  onRetry: () => void;
}> = ({ onRetry }) => {
  return (
    <div className="m-auto flex max-h-[395px] max-w-[255px] flex-col items-center justify-center scale-75 rounded-[6px] bg-white px-[16px] py-[30px] lg:py-2 shadow-card">

      <span className="items-center flex lgx:flex-col lg:flex">
        <CameraPermission className='lg:w-32 lg:m-5' />
        <span className="my-[20px] text-center lg:text-left lg:mb-5 text-[14px] font-medium text-brand-black100">

          Please grant your browser permission to use your webcam.
        </span>
      </span>
      <video className="mt-2 lgx:hidden" src='https://cdn.dresden.vision/video/Camera-permission.mp4' autoPlay loop></video>
      <UIButton className='mt-4 lg:hidden' onClick={onRetry}>Try again</UIButton>
    </div>
  );
};

export default PDCameraView;
